import React, { Fragment } from 'react';
import AccordionPerson from 'shell/components/shared/person';
import UnderageAccordion from './accordion-underage';

interface CancellationUnderageontentProps {
  disabled?: boolean;
}

const CancellationUnderageContent: React.FC<CancellationUnderageontentProps> =
  ({}: CancellationUnderageontentProps) => {
    const [expandedUnderage, setExpandedUnderage] = React.useState<boolean>(false);

    return (
      <Fragment>
        <AccordionPerson disabled />
        <UnderageAccordion
          expanded={expandedUnderage}
          toggle={() => setExpandedUnderage(!expandedUnderage)}
        />
      </Fragment>
    );
  };

CancellationUnderageContent.displayName = 'Cancellation Underage content';
export default CancellationUnderageContent;
